import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const UserCircle: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M3.62897 19.1363C4.62437 18.5242 7.55008 17 12 17C16.4499 17 19.3757 18.5242 20.3711 19.1363M1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12ZM7.5 9.5C7.5 10.6935 7.97411 11.8381 8.81802 12.682C9.66193 13.5259 10.8065 14 12 14C13.1935 14 14.3381 13.5259 15.182 12.682C16.0259 11.8381 16.5 10.6935 16.5 9.5C16.5 8.30653 16.0259 7.16193 15.182 6.31802C14.3381 5.47411 13.1935 5 12 5C10.8065 5 9.66193 5.47411 8.81802 6.31802C7.97411 7.16193 7.5 8.30653 7.5 9.5Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default UserCircle
